module.exports = __webpack_public_path__ + "img/icon-failed.ebdf3904.jpg";